//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    methods: {
        scrollTop () {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    }
};
